<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-col cols="12" sm="12">
            <v-card class="box">
                <v-col cols="12" sm="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Define Grading Scheme...
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <span v-if="card_load">
                        <v-row align="center" justify="center">
                            <template v-if="show_add_new_grading_scheme">
                                <template v-if="grading_scheme_list!=null">
                                    <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                                        <v-autocomplete
                                            dense
                                            required
                                            outlined
                                            rounded
                                            color="#0F2027"
                                            v-model="grading_scheme"
                                            :items="grading_scheme_list"
                                            item-text="name"
                                            item-value="id"
                                            label="Grading Scheme"
                                            persistent-hint
                                            hint="Please select grading scheme"
                                            @change="getGradingDetials"
                                        />
                                    </v-col>
                                </template>
                                <v-col cols="12" sm="4" md="4" class="pt-0 m-0">
                                    <v-btn dense outlined rounded class="button" @click="show_add_new_grading_scheme=false">Add New</v-btn>
                                </v-col>
                            </template>
                            <template v-else>
                                <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                                    <v-text-field color="#0F2027" rounded outlined dense label="Add Grading Scheme" placeholder="Scheme 1" v-model.trim="new_grading_scheme"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" class="pt-0 m-0">
                                    <v-btn style="margin: 5px;" class="button" outlined rounded :loading="add_new_ass_sch_btn" @click="addNewGradingScheme">Save</v-btn>
                                    <v-btn dense class="button" outlined rounded @click="show_add_new_grading_scheme=true">Cancel</v-btn>
                                </v-col>
                            </template>
                        </v-row>
                    </span>
                </v-col>
            </v-card>
            <v-card class="box" :loading="ass_det_card" v-if="grading_scheme!=null">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Grading Scheme Details
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <template class="p-0 m-0">
                        <v-row justify="center">
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field color="#0F2027" label="Grade Name" outlined rounded dense v-model.trim="grade_name"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field color="#0F2027" label="Grade Points" outlined rounded placeholder="10" type="number" dense v-model.trim="grade_point"></v-text-field>
                            </v-col>
                             <v-col cols="12" sm="2" md="2">
                                <v-file-input color="#0F2027" label="Grade File" accept="image/*" outlined dense rounded prepend-icon="mdi-attachment" v-model="remark_file"></v-file-input>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field color="#0F2027" label="Min Value" dense outlined rounded placeholder="10" type="number" v-model="min_value"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field color="#0F2027" label="Max Value" outlined rounded placeholder="30" type="number" dense v-model="max_value"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field color="#0F2027" label="Grade Remark" outlined rounded dense v-model.trim="garde_remark"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field color="#0F2027" label="Range Display Name" outlined rounded dense v-model.trim="range_display_name"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-btn dense class="button" :loading="loader" v-if=" grade_name && grade_point && min_value && max_value && garde_remark" rounded outlined @click="addGradeDetails">Add</v-btn>
                        </v-row>
                    </template>
                    <v-row class="p-0 m-0" v-if="grading_scheme!=null">
                        <v-col class="p-0 m-0" cols="12" sm="6" md="6">
              <v-row dense>
                <v-text-field
                  dense
                  rounded
                  outlined
                  v-model="grading_scheme_name"
                  label="Change Scheme Name"
                  single-line
                  hide-details
                ></v-text-field>
                <v-btn
                  class="button"
                  v-if="grading_scheme_name"
                  small
                  @click="editgradingSchemeName()"
                  >Edit</v-btn
                >
              </v-row>
            </v-col>
                        <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                            <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                        </v-col>
                    </v-row>
                    <v-data-table v-if="grading_scheme_details_list.length > 0 && grading_scheme!=null" dense :headers="headers" :items="grading_scheme_details_list" :search="search" class="elevation-1 mytable">
                        <template v-slot:item.options="{ item }">
                            <v-row>
                                <v-avatar size="33" class="edit-avatar p-3 m-2">
                                    <v-icon class="edit-v-icon" color="#0F2027" @click="editItem(item)">edit</v-icon>
                                </v-avatar>
                                <v-tooltip top color="gray">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-avatar size="33" v-if="item.delete == 'NO'">
                                            <v-icon class="mr-2" v-bind="attrs" v-on="on" color="gray" title="Delete Scheme">delete</v-icon>
                                        </v-avatar>
                                    </template>
                                    <span>
                                        This scheme is offer so you cannot delete it.
                                    </span>
                                </v-tooltip>
                                <v-avatar size="33" class="delete-avatar" v-if="item.delete == 'YES'">
                                    <v-icon class="mr-2 delete-v-icon" color="red" @click="deletegrd(item.grd_id)" title="Delete Scheme">delete</v-icon>
                                </v-avatar>
                            </v-row>
                        </template>
                        <template v-slot:[`item.file_link`]="{item}">
                    <span v-if="item.file_link!='--'">
                        <a :href="item.file_link" target="_blank">
                            <v-icon class="mr-2 v-icon-size" color="#0F2027">mdi-eye</v-icon>
                        </a>
                    </span>
                    <span v-else>--</span>
                </template>
                    </v-data-table>
                    <v-dialog v-model="dialog_delete_que" persistent max-width="500px">
                    <v-card>
                        <v-container>
                            <v-card class="box">
                            <input type="hidden" v-model="deleteItem.delete_id" />
                            <strong>Are you sure you want Delete Assessment Scheme Details??</strong>
                            <v-row justify="center">
                            <v-btn class="button" text @click="dialog_delete_que = false">No</v-btn>
                            <v-btn class="button" text @click="deletescheme()">Yes</v-btn>
                            </v-row>
                            </v-card>
                        </v-container>
                    </v-card>
                </v-dialog>
                     <v-dialog v-model="dialog_edit" persistent max-width="1200px" >
                    <v-card>
                        <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                                <strong>
                                    Edit Grading Scheme Details
                                </strong>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row justify="center">
                                 <!-- {{editeditem}}
                                 -->
                                <v-col cols="12" sm="2" md="2">
                                <v-text-field color="#0F2027" label="Grade Name" outlined rounded dense v-model.trim="editeditem.gradename"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <v-text-field color="#0F2027" label="Grade Points" outlined rounded placeholder="10" type="number" dense v-model.trim="editeditem.gradepoint"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <v-file-input color="#0F2027" label="Grade File" accept="image/*" outlined dense rounded prepend-icon="mdi-attachment" v-model="editeditem.edit_remark_link"></v-file-input>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <v-text-field color="#0F2027" label="Min Value" dense outlined rounded placeholder="10" type="number" v-model="editeditem.min"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <v-text-field color="#0F2027" label="Max Value" outlined rounded placeholder="30" type="number" dense v-model="editeditem.max"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <v-text-field color="#0F2027" label="Grade Remark" outlined rounded dense v-model.trim="editeditem.remark"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <v-text-field color="#0F2027" label="Range Display Name" outlined rounded dense v-model.trim="editeditem.range_display_name"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-btn rounded :loading="loader_edit"  class="button mr-1" @click="save_scheme">Update</v-btn>
                                <v-btn rounded class="button"  @click="dialog_edit = false">Close</v-btn>
                            </v-row>
                        </v-card>
                        </v-col>
                    </v-card>
                     </v-dialog>                            
                </v-card-text>
            </v-card>
        </v-col>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar_msg: null,
                snackbar: false,
                color: "",
                card_load: false,
                show_add_new_grading_scheme: true,
                new_grading_scheme: null,
                add_new_ass_sch_btn: false,
                grading_scheme_list: null,
                grading_scheme: null,
                grading_scheme_details_list: null,
                ass_det_card: false,
                min_value: 0,
                max_value: 0,
                grade_point: 0,
                range_display_name: null,
                grade_name: null,
                garde_remark: null,
                search:null,
                dialog_delete_que:false,
                dialog_edit:false,
                editedIndex: -1,
                remark_file:null,
                loader_edit:false,
                loader:false,
                editeditem:[],
                grading_scheme_name:'',
                deleteItem: {
                    delete_id: "",
                },
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Grade Name",
                        align: "left",
                        sortable: false,
                        value: "gradename",
                    },
                    {
                        text: "Grade Points",
                        align: "left",
                        sortable: false,
                        value: "gradepoint",
                    },
                    {
                        text: "Grade Symbol",
                        align: "left",
                        sortable: false,
                        value: "file_link",
                    },
                    {
                        text: "Min Value",
                        align: "left",
                        sortable: false,
                        value: "min",
                    },
                    {
                        text: "Max Value",
                        align: "left",
                        sortable: false,
                        value: "max",
                    },
                    {
                        text: "Remark",
                        align: "left",
                        sortable: false,
                        value: "remark",
                    },
                    {
                        text: "Range Display Name",
                        align: "left",
                        sortable: false,
                        value: "range_display_name",
                    },
                    {
                        text: "Action",
                        sortable: false,
                        value: "options",
                    },
                ],
            };
        },
        mounted() {
            this.card_load = false;
            axios
                .post("/examination/gradingScheme")
                .then((res) => {
                    this.grading_scheme_list = res.data.grading_scheme_list;
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                    this.card_load = true;
                });
        },
        methods: {
            deletegrd(item){
              this.dialog_delete_que = true;
              this.deleteItem.delete_id = item;
          },
          deletescheme(){
              const formData = {
                  grading_scheme:this.deleteItem.delete_id
              }
               axios
                    .post("/examination/deleteGradingScheme", formData)
                    .then((res) => {
                         if (res.data.status == "YES") {
                              this.showSnackbar("#4caf50", "Grading Scheme Details Deleted successfully");
                              this.getGradingDetials()
                              this.dialog_delete_que = false;
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                        this.dialog_delete_que = false;
                    })
                    .finally(() => {
                        //stop loader
                    });
          },
             editItem(item)
            {
                this.editeditem = Object.assign({}, item);
                this.dialog_edit = true
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            save_scheme(){
                let min = 0
                let max = 0
                if (this.editeditem.gradename == null || this.editeditem.gradename == "") {
                    alert("Please enter grade name!!!");
                    return;
                }
                if (this.editeditem.remark == null || this.editeditem.remark == "") {
                    alert("Please enter grade remark!!!");
                    return;
                }
                min = parseFloat(this.editeditem.min);
                max = parseFloat(this.editeditem.max);
                if (min >= max) {
                    this.showSnackbar("#b71c1c", "Please enter max value greater than min value...");
                    return;
                }
                //  const formData = {
                //     editeditem: this.editeditem,
                // };
                // { "srno": 2, "grd_id": 22, "delete": "YES", 
                // "gr_id": 4, "gradename": "A2",
                //  "file_link": "https://eduplusschool.s3.ap-south-1.amazonaws.com/gardingSchemeDetails/4/22/Grade_Symnols22ghtssq9m95add_organization.png",
                //  "gradepoint": 8, 
                //  "edit_remark_link": null, 
                //  "min": 7, "max": 8, 
                //  "remark": "Poor" }
                 let formData = new FormData();
                  formData.append("min",this.editeditem.min);
                formData.append("max", this.editeditem.max);
                formData.append("gradepoint", this.editeditem.gradepoint);
                formData.append("range_display_name", this.editeditem.range_display_name);
                formData.append("gradename", this.editeditem.gradename);
                formData.append("remark", this.editeditem.remark);
              //  formData.append("grading_scheme",this.editeditem.grading_scheme);
                formData.append("edit_remark_link", this.editeditem.edit_remark_link);
                formData.append("gr_id", this.editeditem.gr_id);
                formData.append("grd_id", this.editeditem.grd_id);
               // formData.append("editeditem", this.editeditem);
               this.loader_edit = true
                axios
                    .post("/examination/editGradingDetials", formData)
                    .then((res) => {
                         if (res.data.status == "YES") {
                           if (res.data.flag == "YES") {
                              this.showSnackbar("#4caf50", "Grading Scheme Details edited successfully");
                              this.getGradingDetials()
                              this.dialog_edit = false;
                              this.loader_edit = false
                           }
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                        this.dialog_edit = false;
                        this.loader_edit = false
                    })
                    .finally(() => {
                        //stop loader
                    });
            },

            editgradingSchemeName() {
               
      if (
        this.grading_scheme_name == null ||
        this.grading_scheme_name == ""
      ) {
        this.showSnackbar("#b71c1c", "Please Add Grading Scheme Name!!!");
        return;
      }
      const data = {
       
        grading_scheme_name: this.grading_scheme_name,
        grading_scheme: this.grading_scheme,
      };
    //  alert( this.grading_scheme_name) ;
      axios
        .post("/examination/editGradingSchemeName", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar(
              "#4caf50",
              "Grading Scheme edited Successfully"
            );
            this.getGradingDetials();
            // alert("after save")
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          //stop loader
        });
    },
            addNewGradingScheme() {
                if (this.new_grading_scheme == null || this.new_grading_scheme == "") {
                    alert("Please enter grading scheme name!!!");
                    return;
                }
                this.add_new_ass_sch_btn = true;
                const formData = {
                    new_grading_scheme: this.new_grading_scheme,
                };
                axios
                    .post("/examination/addGradingScheme", formData)
                    .then((res) => {
                        this.grading_scheme_list = res.data.grading_scheme_list;
                        if (res.data.status != "YES") {
                            alert(res.data.status);
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.show_add_new_grading_scheme = true;
                        this.add_new_ass_sch_btn = false;
                    });
            },
            getGradingDetials() {
                this.ass_det_card = true;
                const formData = {
                    grading_scheme_id: this.grading_scheme,
                };
                axios
                    .post("/examination/getGradingDetials", formData)
                    .then((res) => {
                        this.grading_scheme_details_list = res.data.grading_scheme_details_list;
                        this.ass_det_card = false;
                        this.grading_scheme_name = res.data.grading_scheme_name;
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            addGradeDetails() {
                let min = 0
                let max = 0
                if (this.grade_name == null || this.grade_name == "") {
                    alert("Please enter grade name!!!");
                    return;
                }
                if (this.garde_remark == null || this.garde_remark == "") {
                    alert("Please enter grade remark!!!");
                    return;
                }
                min = parseFloat(this.min_value);
                max = parseFloat(this.max_value);
                if (min >= max) {
                    this.showSnackbar("#b71c1c", "Please enter max value greater than min value...");
                    return;
                }
                // const formData = {
                //     min_value: this.min_value,
                //     max_value: this.max_value,
                //     grade_point: this.grade_point,
                //     grade_name: this.grade_name,
                //     garde_remark: this.garde_remark,
                //     grading_scheme: this.grading_scheme,
                // };
                let formData = new FormData();
                formData.append("min_value", this.min_value);
                formData.append("max_value", this.max_value);
                formData.append("grade_point", this.grade_point);
                formData.append("range_display_name", this.range_display_name);
                formData.append("grade_name", this.grade_name);
                formData.append("garde_remark", this.garde_remark);
                formData.append("grading_scheme", this.grading_scheme);
                formData.append("remark_file", this.remark_file);
                this.loader = true
                axios
                    .post("/examination/saveGradingDetials", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            if (res.data.flag == "NEW") {
                                this.showSnackbar("#4caf50", "Grading Scheme Details Added Successfully");
                                this.getGradingDetials();
                                this.loader = false
                            } else if (res.data.flag == "Exist") {
                                this.showSnackbar("#b71c1c", "Grading Scheme Details Already Exist!!...");
                                this.getGradingDetials();
                                this.loader = false
                            }
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                        this.loader = false
                    })
                    .finally(() => {
                         this.remark_file = null
                         this.range_display_name = null
                        (this.min_value = null), (this.max_value = null), (this.grade_point = null), (this.grade_name = null), (this.garde_remark = null), (this.grading_scheme = null);
                    });
            },
        },
    };
</script>
<style scoped>
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #0f2027 !important;
        margin: 0.2rem !important;
    }
    .edit-avatar:hover {
        background-color: transparent;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
